import { render } from "./ViewChallengeList.vue?vue&type=template&id=31726492&scoped=true"
import script from "./ViewChallengeList.vue?vue&type=script&lang=js"
export * from "./ViewChallengeList.vue?vue&type=script&lang=js"

import "@/css/views/view-challenge-list.css?vue&type=style&index=0&id=31726492&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31726492"]])

export default __exports__